import React from 'react'

const React_Coding_Practice_23 = () => {
  return (
    <div>
      <h1>Coding Pratice 23</h1>
    </div>
  )
}

export default React_Coding_Practice_23
